'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAppearance = _themer.Themer.createTabAppearance({
  base: {},
  hover: {
    backgroundColor: _scales2.default.neutral.N2A
  },
  focus: {
    boxShadow: '0 0 0 2px ' + _scales2.default.primary.P5A
  },
  active: {
    backgroundColor: _scales2.default.primary.P3A,
    color: _scales2.default.primary.P9
  },
  current: {}
});

/**
 * Get the appearance of a `Tab`.
 * @param {string} appearance
 * @return {string} the appearance object.
 */
var getTabAppearance = function getTabAppearance() {
  return defaultAppearance;
};

/**
 * Get the className of a `Tab`.
 * @param {string} appearance
 * @return {string} the appearance class name.
 */
exports.default = (0, _memoizeClassName2.default)(getTabAppearance);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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